export default "__VITE_ASSET__DcKZT0Aj__"